import { createFeatureSelector, createSelector } from '@ngrx/store';
import { StoreArgentinaState } from '../reducers';

export const selectStoreArgentinaState = createFeatureSelector<StoreArgentinaState>('storeArgentina');

export const selectStoreArgentinaLoading = createSelector(
  selectStoreArgentinaState,
  (state: StoreArgentinaState) => state.loading
);

export const selectStoreArgentina = createSelector(
  selectStoreArgentinaState,
  (state: StoreArgentinaState) => state.storeArgentina
);

export const selectStoreArgentinaError = createSelector(
  selectStoreArgentinaState,
  (state: StoreArgentinaState) => state.error
);
